import React, { memo, useCallback, useState } from 'react';

import { bool, func, string } from 'prop-types';
import { IconButton, Input } from '@picsio/ui';
import { CheckIcon, CloseIcon } from '@picsio/icons';

import { productFieldInputProps } from '../constants';
import s from './styles.module.scss';

const FormAdd = memo(({
  onSubmit,
  validate,
  onCancel,
  placeholder = 'Type something',
  placeholder2 = 'Type something',
  errorMessage = null,
  isOption = false,
}) => {
  const [value, setValue] = useState('');
  const [value2, setValue2] = useState('');
  const [hasError, setHasError] = useState(false);
  const [hasError2, setHasError2] = useState(false);

  const handleChange = useCallback((e) => {
    setValue(e.target.value);
    setHasError(!validate(e.target.value));
  }, [validate]);

  const handleChange2 = useCallback((e) => {
    setValue2(e.target.value);
    setHasError2(!e.target.value);
  }, [setValue2]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    if (validate(value) && (!isOption || (isOption && value2))) {
      onSubmit({ value, value2 });
      setValue('');
      if (isOption) setValue2('');
    }
    if (!validate(value)) setHasError(true);
    if (isOption && !value2) setHasError2(true);
  }, [validate, value, onSubmit, value2, isOption]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  }, [onCancel]);

  const showError = hasError && !!value.trim() && !!errorMessage;

  return (
    <form className={s.form} action="#" onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
      <div className={s.formRow}>
        <Input
          value={value}
          error={hasError}
          placeholder={placeholder}
          autoFocus
          inputProps={productFieldInputProps}
          onChange={handleChange}
        />
        <If condition={isOption}>
          <Input
            value={value2}
            error={hasError2}
            placeholder={placeholder2}
            inputProps={productFieldInputProps}
            onChange={handleChange2}
          />
        </If>
        <div className={s.formButtons}>
          <IconButton type="submit" aria-label="Confirm" onClick={handleSubmit}>
            <CheckIcon />
          </IconButton>
          <IconButton type="reset" aria-label="Cancel" onClick={onCancel}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <If condition={showError}>
        <span className={s.formError}>{errorMessage}</span>
      </If>
    </form>
  );
});

FormAdd.propTypes = {
  errorMessage: string,
  isOption: bool,
  placeholder: string,
  placeholder2: string,
  validate: func.isRequired,
  onCancel: func.isRequired,
  onSubmit: func.isRequired,
};

export default FormAdd;
